import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon } from "@mui/material";
const st0 = { fill: "#001c23" };
function WorkWaveLogoStacked(props) {
  const { width = "100%", sx = {}, ...rest } = props;
  return /* @__PURE__ */ jsx(
    SvgIcon,
    {
      "data-testid": "workWaveLogo",
      titleAccess: "WorkWave Logo",
      viewBox: "0 0 521.41 316.36",
      sx: { ...sx, height: "auto", width },
      ...rest,
      children: /* @__PURE__ */ jsxs("g", { id: "color_17_", children: [
        /* @__PURE__ */ jsxs("g", { id: "text_38_", children: [
          /* @__PURE__ */ jsx(
            "path",
            {
              style: st0,
              d: "M515.66 259.71c0 3.23-2.48 5.77-5.72 5.77-3.2 0-5.75-2.54-5.75-5.77 0-3.16 2.55-5.7 5.75-5.7 3.23 0 5.72 2.54 5.72 5.7zm-10.54 0c0 2.83 2.05 5.07 4.85 5.07 2.73 0 4.74-2.25 4.74-5.03 0-2.83-2.01-5.11-4.78-5.11-2.76 0-4.81 2.29-4.81 5.07zm3.93 2.99h-1.29V257c.51-.1 1.23-.17 2.15-.17 1.05 0 1.53.17 1.94.42.3.24.54.69.54 1.25 0 .63-.48 1.11-1.16 1.32v.07c.54.21.85.63 1.02 1.39.17.87.27 1.22.41 1.43h-1.4c-.17-.21-.27-.73-.44-1.39-.1-.63-.44-.9-1.16-.9h-.61v2.28zm.04-3.23h.61c.72 0 1.29-.24 1.29-.84 0-.52-.37-.87-1.19-.87-.34 0-.58.04-.72.07v1.64z"
            }
          ),
          /* @__PURE__ */ jsx("g", { id: "XMLID_113_", children: /* @__PURE__ */ jsxs("g", { id: "XMLID_114_", children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_128_",
                style: st0,
                d: "M68.12 256.18c-2.29 0-4.32 1.52-4.99 3.64l-10.15 31.74-9.14-31.74c-.59-2.12-2.62-3.64-4.82-3.64s-4.14 1.52-4.74 3.64l-9.05 31.65-10.24-31.65c-.68-2.12-2.71-3.64-4.99-3.64-2.88 0-5.25 2.37-5.25 5.25 0 2.37 13.79 43.75 15.48 48.92.67 2.12 2.71 3.64 4.99 3.64 2.29 0 4.4-1.44 4.99-3.64l8.88-30.97 8.88 30.97c.59 2.2 2.62 3.64 4.91 3.64 2.28 0 4.32-1.52 4.99-3.64 1.69-5.16 15.48-46.55 15.48-48.92.02-2.88-2.35-5.25-5.23-5.25"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_127_",
                style: st0,
                d: "m241.28 278.27 13.37-13.12c1.02-1.01 1.61-2.28 1.61-3.72 0-2.88-2.37-5.25-5.25-5.25-1.35 0-2.71.59-3.64 1.52l-24.53 24.03v-19.89c0-3.05-2.45-5.67-5.58-5.67s-5.67 2.54-5.67 5.67v46.46c0 3.13 2.54 5.67 5.67 5.67s5.58-2.63 5.58-5.67v-11.93c3.56-3.56 7.19-7.03 10.75-10.58l15.91 25.64c.93 1.52 2.71 2.54 4.49 2.54 2.88 0 5.16-2.37 5.16-5.25 0-.93-.25-1.86-.76-2.71l-17.11-27.74z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_126_",
                style: st0,
                d: "M333.13 256.18a5.29 5.29 0 0 0-5 3.64l-10.15 31.74-9.14-31.74c-.59-2.12-2.62-3.64-4.82-3.64s-4.14 1.52-4.74 3.64l-9.05 31.65-10.24-31.65c-.68-2.12-2.71-3.64-4.99-3.64-2.88 0-5.25 2.37-5.25 5.25 0 2.37 13.79 43.75 15.48 48.92.68 2.12 2.71 3.64 4.99 3.64 2.29 0 4.4-1.44 4.99-3.64l8.88-30.97 8.89 30.97c.59 2.2 2.62 3.64 4.91 3.64 2.28 0 4.32-1.52 4.99-3.64 1.69-5.16 15.48-46.55 15.48-48.92.01-2.88-2.36-5.25-5.23-5.25"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_125_",
                style: st0,
                d: "M440.28 256.18c-2.03 0-3.89 1.18-4.74 3.05l-15.82 37.83-15.74-37.83c-.76-1.95-2.79-3.05-4.82-3.05-2.79 0-5.16 2.54-5.16 5.33 0 .68.17 1.44.42 2.12l20.56 47.31c.85 1.95 2.71 3.05 4.82 3.05 2.03 0 3.98-1.19 4.74-3.05l20.48-47.31c.34-.68.51-1.44.51-2.2 0-2.88-2.37-5.25-5.25-5.25"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_124_",
                style: st0,
                d: "M496.04 302.73h-26.4V290.2h13.96c2.88 0 5.25-2.28 5.25-5.25 0-2.96-2.37-5.33-5.25-5.33h-13.96v-12.1h25.13c2.88 0 5.33-2.37 5.33-5.33 0-2.88-2.45-5.25-5.33-5.25h-30.71c-3.13 0-5.67 2.45-5.67 5.59v45.11c0 3.13 2.54 5.67 5.67 5.67h31.98c2.88 0 5.33-2.28 5.33-5.25 0-2.88-2.45-5.33-5.33-5.33"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_121_",
                style: st0,
                d: "M109.76 255.93c-16.24 0-28.94 12.95-28.94 29.2s12.69 29.28 28.94 29.28c16.24 0 28.85-13.03 28.85-29.28.01-16.25-12.6-29.2-28.85-29.2m0 48.07c-10.58 0-17.68-8.46-17.68-18.87s7.11-18.79 17.68-18.79 17.6 8.38 17.6 18.79c0 10.4-7.02 18.87-17.6 18.87"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_118_",
                style: st0,
                d: "M198.06 273.87c0-12.36-9.39-16.93-20.56-16.93h-20.98c-3.13 0-5.58 2.46-5.58 5.59v45.87c0 3.13 2.45 5.59 5.58 5.59 3.05 0 5.67-2.45 5.67-5.59v-17.86h15.49c.08.42 9.22 18.7 10.07 20.4.93 1.86 2.79 3.05 4.83 3.05 3.04 0 5.5-2.45 5.5-5.42 0-2.71-7.62-16.76-9.22-19.97 6.15-2.63 9.2-8.13 9.2-14.73m-18.95 7.02h-16.92v-13.54h16.92c4.23 0 7.7 2.37 7.7 6.86-.01 4.48-3.56 6.68-7.7 6.68"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "XMLID_115_",
                style: st0,
                d: "M340.59 306.54c-.25.68-.42 1.44-.42 2.2 0 2.88 2.29 5.25 5.16 5.25 1.23 0 2.33-.41 3.22-1.28.59-.44 1.08-1.01 1.41-1.72.33-.67 7.31-14.64 26.4-16.67l7.47 16.63a5.22 5.22 0 0 0 4.74 3.05c2.96 0 5.33-2.46 5.33-5.33 0-.68-.17-1.44-.51-2.12l-21.66-47.31c-.76-1.78-2.62-3.05-4.65-3.05-2.03 0-3.98 1.1-4.91 3.05l-21.58 47.3zm31.79-21.09c-4.96.83-9.22 2.32-12.85 4.15l7.46-16.15 5.39 12z"
              }
            )
          ] }) })
        ] }),
        /* @__PURE__ */ jsx("g", { id: "color_19_", children: /* @__PURE__ */ jsxs("g", { id: "w-circle_11_", children: [
          /* @__PURE__ */ jsx("circle", { cx: 260.2, cy: 121.08, r: 117.19, fill: "#002d5c" }),
          /* @__PURE__ */ jsxs("g", { id: "_Group_5_39_", children: [
            /* @__PURE__ */ jsx(
              "path",
              {
                d: "M161.59 120.32c4.51.91 8.9-2 9.82-6.5h.01c.92-4.51-1.99-8.91-6.5-9.84-4.51-.92-8.91 1.99-9.84 6.5a8.341 8.341 0 0 0 6.51 9.84zm18.85 13.88c-.1-.49-.24-.97-.42-1.44l-.83-2.89c-1.11-5.28-6.3-8.66-11.58-7.55-5.28 1.11-8.66 6.3-7.55 11.58.1.49.24.97.42 1.44l.83 2.89c1.11 5.28 6.3 8.66 11.58 7.55 5.28-1.11 8.66-6.29 7.55-11.58zm163.32-72.39c-8.22-4.02-13.25 4.79-13.25 4.79l-36.48 86.37s-15.42-47.31-16.1-48.95l-.09-.21.25.8c-.02-.06-.05-.12-.08-.19l-.43-1.42-5.38-16.52c-.79-3.04-2.9-5.56-5.75-6.89-5.14-2.29-11.16.02-13.45 5.16l-23.17 55.4-7.94-23.1-.08-.25c-.02-.06-.06-.13-.09-.19l-.99-2.85-5.18-15.2-.14-.39c-.99-2.42-2.88-4.37-5.27-5.44l-.04.04c-5.14-2.29-11.16.02-13.45 5.16l-11.5 30.4-.36.92c-2.19 4.94.03 10.72 4.97 12.92 3.95 1.75 8.58.71 11.4-2.57.67-.76 1.21-1.63 1.61-2.56l2.22-5.46 13.8 41.87c1.66 5.37 7.36 8.39 12.73 6.73 2.8-.86 5.09-2.89 6.29-5.56l23.48-55.96v.08l22.47 68.09a9.61 9.61 0 0 0 8.82 6.03c6.93.34 9.79-6.03 9.79-6.03l46.95-112.7s2.66-8.28-5.56-12.32zm-77.45 44.77.52-1.25c.01-.01.02-.03.02-.05 0 .01-.01.02-.01.02l-.53 1.28zm-77.66 39.24c-4.92-2.17-10.68.05-12.86 4.97l-3.07 6.85c-2.03 4.84.12 10.42 4.87 12.64 4.89 2.29 10.71.18 13-4.71l2.62-5.92c2.18-4.93.41-11.64-4.56-13.83z",
                fill: "#fff"
              }
            ),
            /* @__PURE__ */ jsxs(
              "linearGradient",
              {
                id: "_Path_9_00000106105203672822250630000008298761532564331140_",
                gradientUnits: "userSpaceOnUse",
                x1: 210.677,
                y1: 1834.903,
                x2: 198.319,
                y2: 1841.755,
                gradientTransform: "matrix(1 0 0 -1 0 1975.364)",
                children: [
                  /* @__PURE__ */ jsx("stop", { offset: 0, stopColor: "#4d4a4a", stopOpacity: 0 }),
                  /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#221f1f" })
                ]
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "_Path_9_38_",
                d: "m229.83 140.15-7.94-23.1-.08-.25c-.88-2.34-3.26-4.83-6.54-3.88-2.63.77-4.03 3.33-4.68 4.77l-5.64 13.78 13.83 41.97c1.66 5.37 7.36 8.39 12.73 6.73 2.8-.86 5.09-2.89 6.29-5.56l2.1-5-10.07-29.46z",
                opacity: 0.7,
                fill: "url(#_Path_9_00000106105203672822250630000008298761532564331140_)"
              }
            ),
            /* @__PURE__ */ jsxs(
              "linearGradient",
              {
                id: "_Path_10_00000183214895269208230380000006185565268787737477_",
                gradientUnits: "userSpaceOnUse",
                x1: 263.148,
                y1: 1839.327,
                x2: 242.85,
                y2: 1850.587,
                gradientTransform: "matrix(1 0 0 -1 0 1975.364)",
                children: [
                  /* @__PURE__ */ jsx("stop", { offset: 0, stopColor: "#221f1f", stopOpacity: 0 }),
                  /* @__PURE__ */ jsx("stop", { offset: 0.02, stopColor: "#221f1f", stopOpacity: 0.04 }),
                  /* @__PURE__ */ jsx("stop", { offset: 0.19, stopColor: "#221f1f", stopOpacity: 0.31 }),
                  /* @__PURE__ */ jsx("stop", { offset: 0.36, stopColor: "#221f1f", stopOpacity: 0.53 }),
                  /* @__PURE__ */ jsx("stop", { offset: 0.53, stopColor: "#221f1f", stopOpacity: 0.71 }),
                  /* @__PURE__ */ jsx("stop", { offset: 0.69, stopColor: "#221f1f", stopOpacity: 0.83 }),
                  /* @__PURE__ */ jsx("stop", { offset: 0.85, stopColor: "#221f1f", stopOpacity: 0.9 }),
                  /* @__PURE__ */ jsx("stop", { offset: 1, stopColor: "#221f1f", stopOpacity: 0.93 })
                ]
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                id: "_Path_10_38_",
                d: "m294.03 152.93-2.68-8.18-13.21-40.12c-.8-2.47-3.19-5.05-6.57-4.07-2.63.77-4.03 3.33-4.68 4.77l-5.6 13.34v.07l22.47 68.09a9.61 9.61 0 0 0 8.82 6.03c6.93.34 9.79-6.03 9.79-6.03l1.56-3.72-9.9-30.18z",
                opacity: 0.7,
                fill: "url(#_Path_10_00000183214895269208230380000006185565268787737477_)"
              }
            )
          ] })
        ] }) })
      ] })
    }
  );
}
export {
  WorkWaveLogoStacked
};
//# sourceMappingURL=WorkWaveLogoStacked.js.map
